import Button from '@zenbusiness/zui/Button';
import DialogHeader from '@zenbusiness/zui/DialogHeader';
import IconButton from '@zenbusiness/zui/IconButton';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ButtonLink = styled(Button)(() => ({
  '&:hover, &:focus': {
    backgroundColor: 'transparent'
  },

  '& span': {
    margin: 0
  }
}));

export const ListInfo = styled(List)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(3),

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr'
  }
}));

export const InfoItem = styled(ListItem)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 0,
  gap: '0.25rem'
}));

export const OptPartner = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'flex-start',
  '& button': {
    width: '100%'
  },

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',

    '& button': {
      width: 'auto'
    },

    '& p': {
      width: '75%'
    }
  }
}));

export const CloseButton = styled(IconButton)(() => ({
  margin: '0 0 0 auto',
  borderRadius: '100%'
}));

export const HeaderModal = styled(DialogHeader)(() => ({
  alignItems: 'center',
  textAlign: 'center',
  padding: '0 !important'
}));
